module.exports = __webpack_public_path__ + "img/label.84d896bc.svg";